// Utility layer (TS-2.5.04) - pure, no side effects. Draft <-> ReferenceValue conversion for
// ReferenceValueForm, split into its own module so that component file can export only a
// component (react-refresh/only-export-components), mirroring projects/lib/projectDraft.ts.
import type { ReferenceValue } from "../../../api/generated/contracts";

export interface ReferenceValueDraft {
  readonly code: string;
  readonly canonicalLabel: string;
  readonly shortLabel: string;
  readonly colorHex: string;
  readonly displayOrder: string;
  readonly sortTier: string;
  readonly groupCode: string;
  readonly aliases: string;
}

export const EMPTY_REFERENCE_VALUE_DRAFT: ReferenceValueDraft = {
  code: "",
  canonicalLabel: "",
  shortLabel: "",
  colorHex: "",
  displayOrder: "0",
  sortTier: "0",
  groupCode: "",
  aliases: "",
};

export function draftFromReferenceValue(value: ReferenceValue): ReferenceValueDraft {
  return {
    code: value.code,
    canonicalLabel: value.canonicalLabel,
    shortLabel: value.shortLabel ?? "",
    colorHex: value.colorHex ?? "",
    displayOrder: String(value.displayOrder),
    sortTier: String(value.sortTier),
    groupCode: value.groupCode ?? "",
    aliases: value.aliases.join(", "),
  };
}

export function referenceValueFromDraft(listCode: string, draft: ReferenceValueDraft, existing: ReferenceValue | null): ReferenceValue {
  return {
    key: existing?.key ?? "",
    listCode,
    code: draft.code,
    canonicalLabel: draft.canonicalLabel,
    shortLabel: draft.shortLabel.trim().length > 0 ? draft.shortLabel.trim() : null,
    colorHex: draft.colorHex.trim().length > 0 ? draft.colorHex.trim() : null,
    displayOrder: Number(draft.displayOrder) || 0,
    sortTier: Number(draft.sortTier) || 0,
    sortRank: existing?.sortRank ?? 0,
    isActive: existing?.isActive ?? true,
    groupCode: draft.groupCode.trim().length > 0 ? draft.groupCode.trim() : null,
    aliases: draft.aliases
      .split(",")
      .map((alias) => alias.trim())
      .filter((alias) => alias.length > 0),
    attributes: existing?.attributes ?? {},
  };
}
